import React, {useState} from 'react';
import styled from 'styled-components';
import {Link} from 'gatsby';
import {breakpointsMediaQueries, COLORS} from '../../style/my-theme';
import CONTENT, {HeaderNavigationItem} from '../content';
import {ContainerLg} from '../components';

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  background: #100f21;
  // background-image: linear-gradient(${props => props.theme.darkVioletHero}, transparent);
  min-height: 64px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  z-index: 2;
  color: black;
  font-family: 'Montserrat', sans-serif;

  ${breakpointsMediaQueries.md},
  ${breakpointsMediaQueries.sm} {
    background-color: #0b162b;
  }
  &.light-theme {
    background-color: ${({theme}: {theme: any}) => theme.lightPageBackground};
    background-image: none;
    border-bottom: 1px solid #d8d8d8;
    a {
      color: black;
    }
    .hamburger-menu {
      svg {
        fill: black;
      }
    }
  }
  .logo-container {
    display: flex;
    flex-flow: wrap;
    margin: 16px 0px 16px 0px;
    ${breakpointsMediaQueries.xl} {
      margin-left: 0px;
    }
    .logo-link {
      line-height: 0;
      ${breakpointsMediaQueries.sm} {
        width: 36px;
        height: 31px;
        background-size: cover;
      }
    }
  }
  .hamburger-menu {
    margin-left: auto;
    display: none;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    &:focus {
      outline: none;
      box-shadow: none;
    }
    ${breakpointsMediaQueries.md},
    ${breakpointsMediaQueries.sm} {
      display: flex;
      align-items: center;
    }
    svg {
      fill: white;
    }
  }
`;

const NavigationContainer = styled.div`
  display: flex;
  margin-left: auto;
  line-height: 30px;
  &.dark-theme {
    .navbar-parent,
    a {
      color: ${props => props.theme.fontColorLT};
      :hover {
        cursor: pointer;
        color: ${COLORS.yellow};
      }
    }
  }
  &.light-theme {
    .navbar-nav {
      background-color: ${({theme}: {theme: any}) => theme.lightPageBackground};
      padding: 16px;
    }
  }
  .btn-ticket {
    background: ${COLORS.yellow};
    color: #212121;
    font-size: 1rem;
    border-radius: 2rem;
    height: 2rem;
    padding: 0 2rem;
    outline: none;
    border: none;
    &:hover {
      background: ${COLORS.yellowLight};
      cursor: pointer;
    }
  }
  .navbar-parent,
  a {
    margin-right: 30px;
    font-size: 16px;
    :last-child {
      margin-right: 0px;
    }
    :hover {
      cursor: pointer;
      color: ${props => props.theme.violetBtn};
    }
  }
  .navbar {
    position: relative;
    &:hover {
      .navbar-nav {
        visibility: visible;
      }
    }
    .navbar-nav {
      display: grid;
      background-color: #100f21;
      width: 100%;
      padding: 0.25rem;
      visibility: hidden;
      position: absolute;
    }
  }
  ${breakpointsMediaQueries.md},
  ${breakpointsMediaQueries.sm} {
    display: none;
    &.visible {
      display: grid;
      grid-gap: 8px;
      width: 100%;
      margin: 16px 0px 8px 0px;
      .navbar {
        .navbar-parent {
          margin-left: 0px;
        }
        .navbar-nav {
          position: relative;
          visibility: visible;
          background-color: transparent;
        }
      }
      a {
        display: block;
        &.navbar-item {
          margin-left: 30px;
        }
      }
    }
    a {
      display: none;
      margin-left: 0px;
    }
  }
`;

const NavigationList = ({
  navigationItems,
  lightBackground,
  isToggled
}: {
  navigationItems: HeaderNavigationItem[];
  lightBackground: boolean;
  isToggled: boolean;
}) => {
  return (
    <NavigationContainer
      className={`${isToggled ? 'visible' : ''} ${lightBackground ? 'light-theme' : 'dark-theme'}`}
    >
      {navigationItems.map((item, index) =>
        item.subItems && item.subItems.length > 0 ? (
          <div key={index} className="navbar subitem">
            <span className="navbar-parent">{item.label}</span>
            <div className="navbar-nav">
              {item.subItems.map((subItem, subIndex) => (
                <Link className="navbar-item" key={subIndex} to={subItem.path}>
                  {subItem.label}
                </Link>
              ))}
            </div>
          </div>
        ) : index === navigationItems.length - 1 ? (
          <Link key={index} to={item.path}>
            <button className="btn-ticket">{item.label}</button>
          </Link>
        ) : item.isURL ? (
          <a className="navbar-item" key={index} href={item.path}>
            {item.label}
          </a>
        ) : (
          <Link key={index} to={item.path}>
            {item.label}
          </Link>
        )
      )}
    </NavigationContainer>
  );
};

const HamburgerBtn = ({onClick}: {onClick: React.MouseEventHandler<HTMLButtonElement>}) => {
  return (
    <button className="hamburger-menu" onClick={onClick}>
      <svg viewBox="0 0 100 80" width="24" height="24">
        <rect width="100" height="8" />
        <rect y="30" width="100" height="8" />
        <rect y="60" width="100" height="8" />
      </svg>
    </button>
  );
};

const Header = ({lightBackground = false}) => {
  const [isToggled, setIsToggled] = useState(false);
  const toggle = () => setIsToggled(!isToggled);

  return (
    <HeaderContainer className={lightBackground ? 'light-theme' : undefined}>
      <ContainerLg style={{width: '100%', overflow: 'initial'}}>
        <div className="logo-container">
          <Link to="/" className="logo-link">
            <img
              src={lightBackground ? CONTENT.LOGO.black : CONTENT.LOGO.white}
              height="30px"
              alt="logo"
            />
          </Link>
          <HamburgerBtn onClick={toggle} />
          <NavigationList
            navigationItems={CONTENT.HEADER_NAVIGATION_ITEMS}
            lightBackground={lightBackground}
            isToggled={isToggled}
          />
        </div>
      </ContainerLg>
    </HeaderContainer>
  );
};

export default Header;
